import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from 'rxjs';
import { Store } from "@ngrx/store";
import { environment } from "../../../environments/environment";
import { HelperService } from '../helper/helper.service';
import {
  fetchCommissionGroup,
  deleteCommissionGroup,
  addCommissionGroup,
  updateCommissionGroup,
  getCommissionGroup,
  fetchCommissionGroupsByAffiliate
} from "../../store/commission-group/commission-groups.actions";
import { getCommissionGroupsSelector, getCommissionGroupSelector } from '@store/commission-group/commission-groups.selectors';
import { IState } from '@models/index';


@Injectable({
  providedIn: "root"
})
export class CommissionGroupService {
  backendUrl = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private store: Store<{ commissionGroup: string }>
  ) {}

  getCommissionGroupsSelector(): Observable<IState> {
    return this.store.select(getCommissionGroupsSelector);
  }

  getCommissionGroupSelector(): Observable<IState> {
    return this.store.select(getCommissionGroupSelector);
  }

  fetchCommissionGroups(page: number, campaignID: string, filterOptions: any) {
    this.store.dispatch(fetchCommissionGroup({ page, campaignID, filterOptions }));
  }

  fetchCommissionGroup(id: string) {
    this.store.dispatch(getCommissionGroup({ id }))
  }

  deleteCommissionGroup(id: string) {
    this.store.dispatch(deleteCommissionGroup({ id }));
  }

  addCommissionGroup(commissionGroup: any) {
    this.store.dispatch(addCommissionGroup({ commissionGroup }));
  }

  updateCommissionGroup(commissionGroup: any) {
    this.store.dispatch(updateCommissionGroup({ commissionGroup }));
    this.store.dispatch(updateCommissionGroup({ commissionGroup })); 
  }

  fetchCommissionGroupsByAffiliate(page: number, affiliateID: string, filterOptions: any = {}) {
    this.store.dispatch(fetchCommissionGroupsByAffiliate({ page, affiliateID, filterOptions }));
  }

  getCommissionGroups(page: number, campaignID: string, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);

    return this.http.get(`${this.backendUrl}/campaigns/campaign/${campaignID}/commission-groups?${queryString}`);
  }

  getCommissionGroupsByAffiliate(page: number, ID: string, filterOptions: any = { }) {
    const queryparams = { ...{ page }, ...filterOptions };
    const queryString = HelperService.generateQueryParams(queryparams);
    return this.http.get(`${this.backendUrl}/commission-groups/user/${ID}/commission-group?${queryString}`); 
  }

  getCommissionGroup(id: string) {
    return this.http.get(`${this.backendUrl}/commission-groups/group/${id}`);
  }

  removeCommissionGroup(id: string) {
    return this.http.delete(`${this.backendUrl}/commission-groups/group/${id}`);
  }

  insertCommissionGroup(commissionGroup: any) {
    return this.http.post(`${this.backendUrl}/commission-groups/group`, commissionGroup);
  }

  renewCommissionGroup(commissionGroup: any) {
    return this.http.patch(`${this.backendUrl}/commission-groups/group/${commissionGroup.id}`, commissionGroup)
  }

}
